import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useLocation, useNavigate } from 'react-router-dom';

const AuthError = () => {
  const [errorMessage, setErrorMessage] = useState('Unbekannter Fehler bei der Authentifizierung');
  const location = useLocation();
  const navigate = useNavigate();

  const [errorDetails, setErrorDetails] = useState('');

  useEffect(() => {
    // Extrahiere Fehlermeldung und Details aus der URL
    const params = new URLSearchParams(location.search);
    const errorParam = params.get('error');
    const detailsParam = params.get('details');
    
    if (errorParam) {
      setErrorMessage(decodeURIComponent(errorParam));
    }
    
    if (detailsParam) {
      setErrorDetails(decodeURIComponent(detailsParam));
    }
  }, [location]);

  const handleBackToHome = () => {
    navigate('/');
  };

  const handleTryAgain = () => {
    // Navigiere zur Startseite und öffne automatisch den OAuth-Dialog
    navigate('/?openauth=true&authRetry=true');
  };

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '100vh',
        bgcolor: '#f8fafc',
        p: 3
      }}
    >
      <Paper 
        elevation={3} 
        sx={{ 
          p: 4, 
          borderRadius: 3, 
          textAlign: 'center',
          maxWidth: 480
        }}
      >
        <ErrorOutlineIcon 
          sx={{ 
            fontSize: 70, 
            color: '#ef4444', 
            mb: 3 
          }} 
        />
        <Typography 
          variant="h5" 
          component="h1" 
          sx={{ 
            color: '#1e293b', 
            mb: 3, 
            fontWeight: 700 
          }}
        >
          Fehler bei der Authentifizierung
        </Typography>
        <Typography paragraph sx={{ mb: 2, color: '#64748b' }}>
          {errorMessage}
        </Typography>
        
        {errorDetails && (
          <Typography 
            variant="body2" 
            sx={{ 
              mb: 4, 
              p: 2, 
              bgcolor: 'rgba(239, 68, 68, 0.05)', 
              borderRadius: 2, 
              border: '1px solid rgba(239, 68, 68, 0.2)',
              color: '#7f1d1d',
              textAlign: 'left',
              fontSize: '0.875rem'
            }}
          >
            <strong>Details:</strong> {errorDetails}
          </Typography>
        )}
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button 
            variant="outlined" 
            color="primary" 
            onClick={handleBackToHome}
            sx={{ 
              borderRadius: 2,
              py: 1,
              px: 3,
              textTransform: 'none',
              fontWeight: 600
            }}
          >
            Zurück zur Startseite
          </Button>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleTryAgain}
            sx={{ 
              borderRadius: 2,
              py: 1,
              px: 3,
              textTransform: 'none',
              fontWeight: 600
            }}
          >
            Erneut versuchen
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default AuthError;